import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-profile-banner" }
const _hoisted_2 = {
  class: "gfu-layout__main gfu-layout__main--extranarrow _pb-0",
  "data-qa": "user-profile:Header"
}
const _hoisted_3 = { class: "_flexcol _jc-sb _ai-c _fd-r--m _gap-2" }
const _hoisted_4 = { class: "gfu-media__body _fo" }
const _hoisted_5 = { class: "_flex _gap-1" }
const _hoisted_6 = {
  class: "gfu-profile-banner__name gfu-hd gfu-hd--h1 _tc--inherit _toe",
  "data-qa": "user-profile:Username"
}
const _hoisted_7 = {
  class: "gfu-profile-banner__followers _tc--light gfu-bt gfu-bt--caption",
  "data-qa": "user-profile:FollowersCount"
}
const _hoisted_8 = {
  key: 0,
  class: "_mt-1"
}
const _hoisted_9 = {
  class: "gfu-profile-banner__bio _tc--light _mt-2",
  "data-qa": "user-profile:Bio"
}
const _hoisted_10 = { class: "gfu-profile-banner__social _flex _ai-c _tc--light _mt-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_icon_base_label = _resolveComponent("icon-base-label")
  const _component_user_follow_button = _resolveComponent("user-follow-button")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_external_link = _resolveComponent("external-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(['gfu-media gfu-1of1 gfu-2of3--m', {'_ai-c': !$options.hasLabel}])
        }, [
          _createVNode(_component_base_image, {
            src: $props.avatarUrl,
            alt: $props.nickname,
            width: "64",
            height: "64",
            class: "gfu-avatar gfu-avatar--clean _mr-3",
            loading: "lazy",
            "data-qa": "user-profile:Avatar"
          }, null, 8 /* PROPS */, ["src", "alt"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString($props.nickname), 1 /* TEXT */),
              ($options.isUserVerified)
                ? (_openBlock(), _createBlock(_component_icon_base_label, _mergeProps({ key: 0 }, $options.verifiedLabelModel, {
                    "data-qa": $options.verifiedLabelModel.dataQa
                  }), null, 16 /* FULL_PROPS */, ["data-qa"]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString($options.formattedFollowersLabel), 1 /* TEXT */),
            ($options.hasLabel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.userAchievedLabels, (label) => {
                    return (_openBlock(), _createBlock(_component_icon_base_label, _mergeProps({
                      key: label.name
                    }, { ref_for: true }, label, {
                      "data-qa": label.dataQa
                    }), null, 16 /* FULL_PROPS */, ["data-qa"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ], 2 /* CLASS */),
        ($options.isFollowingEnabled)
          ? (_openBlock(), _createBlock(_component_user_follow_button, {
              key: 0,
              nickname: $props.nickname,
              "user-url-name": $props.userUrlName,
              "user-id": $options.userId,
              class: "gfu-1of1 gfu-1of3--m",
              "data-qa": "user-profile:FollowButton"
            }, null, 8 /* PROPS */, ["nickname", "user-url-name", "user-id"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString($options.bio), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.socialLinks, (link) => {
          return (_openBlock(), _createBlock(_component_external_link, {
            key: link.name,
            class: "_mr-2 gfu-link gfu-link--nofx",
            href: link.url,
            "data-qa": `user-profile-social-link:${link.name}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                name: link.iconName,
                "icon-namespace": "brands",
                size: "lg"
              }, null, 8 /* PROPS */, ["name"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href", "data-qa"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}